import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//Para PDF
import * as jsPDF from 'jspdf';
//PDF
import * as _html2canvas from "html2canvas";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');

@Component({
  selector: 'app-simulacion-esquema-ahorrador',
  templateUrl: './simulacion-esquema-ahorrador.component.html',
  styleUrls: ['./simulacion-esquema-ahorrador.component.scss']
})
export class SimulacionEsquemaAhorradorComponent implements OnInit {

  @Input() esquema_inversion: any = {};
  @Output()
  enviaFlag: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isLoading: boolean = false;
  public inversionId : number = 0;
  public fondeadorID : number = 0;
  public inversion : any = {};
  public inversiones_fondeador : any [] = [];  
  public lista_incrementos : any [] = [];  
  public tabla_inversion: any[] = [];
  public numMeses: number = 0;
  public esAhorrador : boolean = false;
  public fechaTemp: any = null;
  //Variables para ahorradores
  public total_aportaciones : number = 0;
  public rendimiento_total : number = 0;
  public total_iva : number = 0;
  public total_neto : number = 0;
  public ahorro_total : number = 0;
  //Rendimiento ganado
  public rendimiento_ganado = 0;
  public simulacionAhorrador: boolean = false;

  constructor() { }

  ngOnInit() {
    this.obtenerInversiones();
  }

  public obtenerInversiones(){
    this.inversion = this.esquema_inversion;
    var fechaPago = this.inversion.fecha_inicio_inversion;
    //Obtenemos el dia del pago
    fechaPago = fechaPago.split(" ")[0].split("-")[2];
    
    console.log("Inversión ID: ", this.inversion);

    //Aseguramos que el monto sea un número
    if (typeof this.inversion.monto != "number"){
      this.inversion.monto = parseFloat(this.inversion.monto)
    }
    
    //Obtener tasa de interés mensual y la de retención
    var interes = this.inversion.tasa_interes/12
    this.inversion.tasa_interes_mensual = Math.round((interes + Number.EPSILON) * 100)/100;
    
    //console.log("Inversiones", this.inversiones_fondeador);
    if(this.inversion.tipo_fondeador == "ahorrador"){
      console.log("Entro al if ahorrador");
      this.esAhorrador = true;
      //Variables
      this.inversion.mes_numero = 0;
      this.inversion.periodo_dias = 0;
      //this.inversion.saldo_inicial = 0;
      this.inversion.capital = 0;
      //this.inversion.rendimiento = 0;
      this.inversion.interes_generado = 0;
      this.inversion.iva = (this.inversion.iva/100);
      this.inversion.interes_acumulado = 0;
      this.inversion.saldo_final = 0;
      this.numMeses = this.inversion.plazo/this.inversion.periodicidad;
      //Copiamos el json al nuevo arreglo
      for (let i = 0; i < this.numMeses; i++) {
        this.inversiones_fondeador.push(Object.assign({} , this.inversion));
      }
      this.calcularTablaAhorradores();

    }
  }

  public calcularTablaAhorradores(){
    this.total_aportaciones = 0;
    this.rendimiento_total = 0;
    this.total_iva = 0;
    this.total_neto = 0;
    this.ahorro_total = 0;
    //Campos de fecha normal
    // var fecha = this.inversiones_fondeador[0].fecha_inicio_inversion.split(" ")[0];
    // var dia = parseInt(fecha.split("-")[2]);
    // var mes = parseInt(fecha.split("-")[1]);
    // var anio = parseInt(fecha.split("-")[0]);
    this.fechaTemp = new Date(this.inversiones_fondeador[0].fecha_inicio_inversion.replace(/-/g, '\/'));
    this.fechaTemp = this.fechaTemp.toISOString();
    this.fechaTemp = this.fechaTemp.split("T")[0];
    //Tasa interes
    //Se divide la tasa de interes entre 360 ya que es anual
    var tasaInteres = ((this.inversion.tasa_interes/100)/360);
    //Asignamos las fechas de pago
    for (let i = 0; i < this.inversiones_fondeador.length; i++) {
      //this.inversiones_fondeador[i].fecha_pago = (anio+"-"+mes+"-"+dia);
      this.inversiones_fondeador[i].mes_numero = i+1;
      this.inversiones_fondeador[i].periodo_dias = (this.inversiones_fondeador[i].periodicidad * (i+1));
      if(i == 0){
        //Al iniciar no existe rendimiento
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i].monto;
        this.inversiones_fondeador[i].interes_generado = (tasaInteres * (this.inversion.periodicidad * this.inversiones_fondeador[i].capital));
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].interes_acumulado = this.inversiones_fondeador[i].interes_generado;
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].interes_acumulado = this.inversiones_fondeador[i].interes_generado;
        }
        this.inversiones_fondeador[i].iva = (this.inversiones_fondeador[i].interes_generado * this.inversion.iva);
        this.inversiones_fondeador[i].neto_ciclo = (this.inversiones_fondeador[i].interes_generado -  this.inversiones_fondeador[i].iva);
        //Aquí no necesitamos saldo final
        //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
      }else if(i == this.inversiones_fondeador.length - 1){
        //En el último mes ya no se tiene monto de aportación
        //---Se calculan las fechas de pago---
        this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
        this.fechaTemp.setDate(this.fechaTemp.getDate() + this.inversiones_fondeador[i].periodicidad);
        this.fechaTemp = this.fechaTemp.toISOString();
        this.fechaTemp = this.fechaTemp.split("T")[0];
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        //Calculos de saldos y rendimiento
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].capital = (this.inversiones_fondeador[i-1].capital +  this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].interes_generado);
          this.inversiones_fondeador[i].interes_generado = (tasaInteres * (this.inversion.periodicidad * this.inversiones_fondeador[i].capital));
          this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i-1].capital + this.inversiones_fondeador[i].monto;
          this.inversiones_fondeador[i].interes_generado = (tasaInteres * (this.inversion.periodicidad * this.inversiones_fondeador[i].capital));
          this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
        }
        this.inversiones_fondeador[i].iva = (this.inversiones_fondeador[i].interes_generado * this.inversion.iva);
        this.inversiones_fondeador[i].neto_ciclo = (this.inversiones_fondeador[i].interes_generado -  this.inversiones_fondeador[i].iva);
        //No lleva saldo final
        //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
        //Ahorro total
        this.ahorro_total = this.inversiones_fondeador[i].saldo_final;
        //El capital ahorrado es el último valor del capital
        this.total_aportaciones = this.inversiones_fondeador[i].capital;
      }else{
        //Demás meses se calculan en base a las reglas
        //---Se calculan las fechas de pago---
        this.fechaTemp = new Date(this.inversiones_fondeador[i-1].fecha_pago);
        this.fechaTemp.setDate(this.fechaTemp.getDate() + this.inversiones_fondeador[i].periodicidad);
        this.fechaTemp = this.fechaTemp.toISOString();
        this.fechaTemp = this.fechaTemp.split("T")[0];
        this.inversiones_fondeador[i].fecha_pago = this.fechaTemp;
        //Calculos de saldos y rendimiento
        if(this.inversion.capitalizacion == 1){
          //Si capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].capital = (this.inversiones_fondeador[i-1].capital +  this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].interes_generado);
          this.inversiones_fondeador[i].interes_generado = (tasaInteres * (this.inversion.periodicidad * this.inversiones_fondeador[i].capital));
          this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
        }else if(this.inversion.capitalizacion == 3){
          //No capitaliza, acumula y retira al final
          this.inversiones_fondeador[i].capital = this.inversiones_fondeador[i-1].capital + this.inversiones_fondeador[i].monto;
          this.inversiones_fondeador[i].interes_generado = (tasaInteres * (this.inversion.periodicidad * this.inversiones_fondeador[i].capital));
          this.inversiones_fondeador[i].interes_acumulado = (this.inversiones_fondeador[i].interes_generado + this.inversiones_fondeador[i-1].interes_acumulado);
        }
       
        this.inversiones_fondeador[i].iva = (this.inversiones_fondeador[i].interes_generado * this.inversion.iva);
        this.inversiones_fondeador[i].neto_ciclo = (this.inversiones_fondeador[i].interes_generado -  this.inversiones_fondeador[i].iva);
        //No lleva saldo final
        //this.inversiones_fondeador[i].saldo_final = (this.inversiones_fondeador[i].capital + this.inversiones_fondeador[i].rendimiento);
        
      }
      
      this.rendimiento_total = this.rendimiento_total + this.inversiones_fondeador[i].interes_generado;
      this.total_iva = this.total_iva + this.inversiones_fondeador[i].iva;
      this.total_neto = this.total_neto + this.inversiones_fondeador[i].neto_ciclo;
      
    }
    console.log("Tabla final: ", this.inversiones_fondeador);    
    
  }

  public close(){
    console.log("flag: ", this.simulacionAhorrador);
    this.enviaFlag.emit(this.simulacionAhorrador);
    
  }

  //Función para crear PDF
  //Alternatibva para guardar pdf pero renderiza el html
  public downloadPDF() {
    this.isLoading=true;
    // Extraemos el
    const DATA = document.getElementById('htmlData');
    //const jsPDF = require('jspdf')
    const doc = new jsPDF('p');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/jpg');
      // Add image Canvas to PDF
      const bufferX = 15;
      const bufferY = 15;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'JPEG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((docResult) => {
      this.isLoading=false;
      docResult.save("Simulacion_Plazo"+this.esquema_inversion.plazo+"dias");
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/simulacion-esquema-ahorrador/simulacion-esquema-ahorrador.component.ts